import { useTranslation } from 'react-i18next';

export default function ProblemSolution() {
  const { t } = useTranslation('home');

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4">
              Problema &amp; Solução
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
              {t('problem_title')}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              {t('problem_text')}
            </p>
          </div>

          <div className="flex-1 bg-background-50 rounded-2xl p-8 md:p-10">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              {t('solution_title')}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {t('solution_text')}
            </p>
            <div className="mt-6 grid grid-cols-2 gap-3">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                  <i className="ri-refresh-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">
                  {t('solution_feature_1')}
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                  <i className="ri-fire-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">
                  {t('solution_feature_2')}
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                  <i className="ri-star-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">
                  {t('solution_feature_3')}
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                  <i className="ri-link text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">
                  {t('solution_feature_4')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}